import store from '@/store';

function swapCustomFieldNameWithCustomFieldId(quickReplyText) {
  const customFields = store.getters['contact/customFieldList'];
  const currentOrganisation = store.getters['organisation/currentOrganisation'];
  const foundTags = quickReplyText.match(/{{(\w+|\s)+}}/g) || [];
  foundTags.forEach((tag) => {
    const tagName = tag.replace(/^{{(.*)}}$/, '$1');
    // Skip if it is one of the default tags ---------------------------
    if (['contact name', 'number name'].includes(tagName)) {
      return;
    }
    // -----------------------------------------------------------------
    const targetCustomField = customFields[currentOrganisation.id].find(cf => cf.name === tagName);
    if (targetCustomField) {
      quickReplyText = quickReplyText.replace(tag, `{{_${targetCustomField.id}_}}`);
    } else {
      quickReplyText = quickReplyText.replace(tag, '{{_deleted_}}');
    }
  });

  return quickReplyText;
}

function swapCustomFieldIdWithCustomFieldName(quickReplyText = '') {
  const customFields = store.getters['contact/customFieldList'];
  const currentOrganisation = store.getters['organisation/currentOrganisation'];
  const foundTags = quickReplyText.match(/{{_(\w+|-)+_}}/g) || [];
  const foundUnknownTags = quickReplyText.match(/{{(\w+|-|\s)+}}/g) || [];

  foundTags.forEach((tag) => {
    const match = tag.match(/^{{_(.*)_}}$/);
    const targetCustomField = customFields[currentOrganisation.id] ? customFields[currentOrganisation.id].find(cf => cf.id === match[1]) : null;
    if (targetCustomField) {
      quickReplyText = quickReplyText.replace(tag, `{{${targetCustomField.name}}}`);
    } else {
      quickReplyText = quickReplyText.replace(tag, '{{deleted}}');
    }
  });

  // Proccess all unknown custom fields instances
  foundUnknownTags.forEach((tag) => {
    // Skip if it is one of the default tags ---------------------------
    if (['{{contact_name}}'].includes(tag)) {
      quickReplyText = quickReplyText.replace(tag, '{{contact name}}');
      return;
    }
    if (['{{business_name}}'].includes(tag)) {
      quickReplyText = quickReplyText.replace(tag, '{{number name}}');
      return;
    }
    // -----------------------------------------------------------------
    quickReplyText = quickReplyText.replace(tag, '{{deleted}}');
  });

  quickReplyText = quickReplyText.replaceAll('{{deleted}}', '{{*Deleted tag*}}');
  return quickReplyText;
}

function findDeletedCustomFelds(text = '') {
  const customFields = store.getters['contact/customFieldList'];
  const currentOrganisation = store.getters['organisation/currentOrganisation'];
  const foundTags = text.match(/{{(\w+|-|\s)+}}/g) || [];
  foundTags.forEach((tag) => {
    if (['{{contact_name}}', '{{contact name}}', '{{business_name}}', '{{number name}}'].includes(tag)) {
      return;
    }
    const match = tag.match(/^{{(.*)}}$/);
    if (match) {
      const targetCustomField = customFields[currentOrganisation.id] ? customFields[currentOrganisation.id].find(cf => cf.name === match[1]) : null;
      if (!targetCustomField) {
        text = text.replace(tag, '{{*Deleted tag*}}');
      }
    }
  });

  return text;
}

/**
 * Populates real contact values into the custom field position on the message.
 *
 * @param {*} text String with custom fields needing to be replaced.
 * @returns Text with values in place of custom fields.
 */
function populateCoustomFields(text = '') {
  const customFields = store.getters['contact/customFieldList'];
  const contact = store.getters['contactDetails/contactData'];
  const currentOrganisation = store.getters['organisation/currentOrganisation'];
  const activeConversation = store.getters['chat/activeConversation'];
  const foundTags = text.match(/{{(\w+|-|\s)+}}/g) || [];

  foundTags.forEach((tag) => {
    if (['{{contact_name}}', '{{contact name}}'].includes(tag)) {
      text = text.replace(new RegExp(`${tag}[ ]{0,1}`, 'g'), activeConversation.contact.name);
    } else if (['{{business_name}}', '{{number name}}'].includes(tag)) {
      text = text.replace(new RegExp(`${tag}[ ]{0,1}`, 'g'), activeConversation.business_name);
    } else {
      const match = tag.match(/^{{(.*)}}$/);
      if (match) {
        const targetCustomField = customFields[currentOrganisation.id] ? customFields[currentOrganisation.id].find(cf => cf.name === match[1]) : null;
        if (!targetCustomField) {
          text = text.replace(tag, '-');
        } else {
          const realValue = contact.meta_data.custom_fields[targetCustomField.id] ? contact.meta_data.custom_fields[targetCustomField.id] : '-';
          text = text.replaceAll(tag, realValue);
        }
      }
    }
  });
  return text;
}

export {
  swapCustomFieldNameWithCustomFieldId,
  swapCustomFieldIdWithCustomFieldName,
  findDeletedCustomFelds,
  populateCoustomFields,
};
